<template>
  <!--==== IndustryArea ====-->
  <div class="page_header">
    <h1>{{ content.industry_area_title }}</h1>
  </div>
  <div :class="['industry_area_home', language === 'cn' ? 'font-cn' : 'font-en']">
    <div
      class="industry_area_container"
      v-for="(area, index) in content.industry_area"
      :key="index"
    >
      <div :id="area.id" class="section">
        <div class="header">{{ area.title }}</div>
        <div class="content">
          <img :src="area.image" class="image" />
          <div class="text_column">
            <div class="text">
              {{ area.text }}
            </div>
            <div class="button_link">
              <router-link :to="{ path: area.link.path, query: { sector: area.id } }">
                {{ content.industry_area_button }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import en from "@/data/industry_area_en.js";
import cn from "@/data/industry_area_cn.js";

export default {
  mixins: [en, cn],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>

<style scoped>
/* INDUSTRYAREA */
.industry_area_container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 32px;
  box-sizing: border-box;
}

.industry_area_home {
  padding: 32px 0;
}

.section {
  position: relative;
  margin-bottom: 28px;
  padding: 0;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.header {
  background-color: #ff0000;
  color: white;
  padding: 14px 24px;
  text-align: left;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: 1px;
}

.content {
  display: flex;
  align-items: stretch;
  gap: 28px;
  padding: 28px;
  flex-wrap: wrap;
}

.image {
  flex: 1 1 420px;
  max-width: 560px;
  width: 100%;
  height: auto;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  background-color: #f0f0f0;
  border-radius: 4px;
  flex-shrink: 0;
}

.text_column {
  flex: 1 1 320px;
  display: flex;
  flex-direction: column;
  padding: 8px 4px;
}

.text {
  font-size: 17px;
  line-height: 1.85;
  color: #333;
  flex: 1;
}

.button_link {
  margin-top: 24px;
  text-align: right;
}

.button_link a {
  display: inline-block;
  padding: 12px 28px;
  background-color: #b90303;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 15px;
  letter-spacing: 1px;
  transition: background-color 0.2s, transform 0.2s;
}

.button_link a:hover {
  background-color: #ff0000;
  transform: translateY(-2px);
}

/* Media queries for responsiveness */
@media (max-width: 768px) {
  .industry_area_container {
    padding: 0 16px;
  }
  .content {
    flex-direction: column;
    padding: 20px;
    gap: 16px;
  }
  .image {
    max-width: 100%;
    aspect-ratio: 16 / 9;
  }
  .header {
    font-size: 1.15rem;
    text-align: center;
  }
}
</style>


